<template>
  <div>
    <div class="WebApplicationFirewallMonitor-title">
      <div>
        {{ $t("alarms.WebApplicationFirewall.WebApplicationFirewall") }}
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane
          :label="
            $t('alarms.WebApplicationFirewall.WebApplicationFirewallList')
          "
        >
          <div class="WebApplicationFirewallMonitor-top">
            <web-application-firewall-monitor-search></web-application-firewall-monitor-search>
          </div>
          <table-web-application-firewall></table-web-application-firewall>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import WebApplicationFirewallMonitorSearch from "../webApplicationFirewall/WebApplicationFirewallMonitorSearch";
import TableWebApplicationFirewall from "../webApplicationFirewall/TableWebApplicationFirewall";
import LogWarningSearch from "../logs/log/LogWarningSearch";
import TableLogWarning from "../logs/log/TableLogWarning";

export default {
  name: "WebApplicationFirewallMonitor",
  components: {
    WebApplicationFirewallMonitorSearch,
    TableWebApplicationFirewall,
    LogWarningSearch,
    TableLogWarning,
  },
  data() {
    return {
      currentTab: "",
    };
  },
  methods: {},
};
</script>

<style scoped>
.WebApplicationFirewallMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.WebApplicationFirewallMonitor-title > div:nth-child(1) {
  float: left;
}
.WebApplicationFirewallMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.WebApplicationFirewallMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/webApplicationFirewall/WebApplicationFirewallMonitor.vue